import type { FeedbackOrigin } from "@productlane/db/browser"

import { customChannelLabel } from "./custom-channel"

export const FeedbackOriginTextRecord: Record<FeedbackOrigin, string> = {
	API: "API",
	INAPP: "in App",
	PORTAL: "Feedback portal",
	SUPPORT_PORTAL: "Support portal",
	EMAIL: "Email",
	SLACK: "Slack",
	SLACK_CONNECT: "Slack",
	INTERCOM: "Intercom",
	INTERCOM_ATTACHMENT: "Intercom",
	FRONT_ATTACHMENT: "Front",
	ZAPIER: "Zapier",
	ZENDESK: "Zendesk",
	ZENDESK_ATTACHMENT: "Zendesk",
	HUBSPOT: "Hubspot",
	PLAIN: "Plain",
	CALENDAR: "Call",
	WIDGET: "Widget",
	AI_CHAT: "AI Chat",
	UPVOTE: "Upvote",
	LIVE_CHAT: "Live Chat",
	TEAMS: "Microsoft Teams",
	LINEAR: "Linear",
	CUSTOM: "Custom channel",
} as const

export const FeedbackOriginPhraseRecord: Record<FeedbackOrigin, string> = {
	API: "Created via API",
	INAPP: "Created in App",
	PORTAL: "Submitted via Feedback portal",
	SUPPORT_PORTAL: "Submitted via Support portal",
	EMAIL: "Received via Email",
	SLACK: "Received via Slack",
	SLACK_CONNECT: "Received via Slack",
	INTERCOM: "Received via Intercom",
	INTERCOM_ATTACHMENT: "Received via Intercom",
	FRONT_ATTACHMENT: "Received via Front",
	ZAPIER: "Created via Zapier",
	ZENDESK: "Received via Zendesk",
	ZENDESK_ATTACHMENT: "Received via Zendesk",
	HUBSPOT: "Received via Hubspot",
	PLAIN: "Received via Plain",
	CALENDAR: "Received via Call",
	WIDGET: "Submitted via Widget",
	AI_CHAT: "Created via AI Chat",
	UPVOTE: "Submitted via Upvote",
	LIVE_CHAT: "Received via Live Chat",
	TEAMS: "Received via Microsoft Teams",
	LINEAR: "Received via Linear",
	CUSTOM: "Received via a custom channel",
} as const

/** The source name an inbox shows for a thread, naming a custom channel. */
export function feedbackOriginText(
	origin: FeedbackOrigin,
	customChannel?: string | null,
): string {
	return origin === "CUSTOM"
		? customChannelLabel(customChannel)
		: FeedbackOriginTextRecord[origin]
}

/** "Received via WhatsApp" for a custom channel, the stock phrase otherwise. */
export function feedbackOriginPhrase(
	origin: FeedbackOrigin,
	customChannel?: string | null,
): string {
	return origin === "CUSTOM" && customChannel
		? `Received via ${customChannelLabel(customChannel)}`
		: FeedbackOriginPhraseRecord[origin]
}
